import script from "./SubastaLotesList.vue?vue&type=script&setup=true&lang=js"
export * from "./SubastaLotesList.vue?vue&type=script&setup=true&lang=js"

import "./SubastaLotesList.vue?vue&type=style&index=0&id=9eca0576&lang=css"

const __exports__ = script;

export default __exports__